import React, { useEffect, useRef, useState } from 'react'
import '../Landing/landing.css'
import './Badge.css'
import { toast, ToastContainer } from 'react-toastify';

const Badge = () => {
    const textRef = useRef(null);
    const letters = "abcdefghijklmnopqrstuvwxyz";
    let interval = null;
    const [badgeId, setBadgeId] = useState('')


    const matrixEffect = () => {
    let iteration = 0;

    clearInterval(interval);

    interval = setInterval(() => {
        textRef.current.innerText =  textRef.current.innerText
        .split("")
        .map((letter, index) => {
            if(index < iteration) {
            return textRef.current.dataset.value[index];
            }
        
            return letters[Math.floor(Math.random() * 26)]
        })
        .join("");
        
        if(iteration >= textRef.current.dataset.value.length){ 
        clearInterval(interval);
        }
        
        iteration += 1 / 3;
    }, 30);
    }

    const verifyBadge = async (id) => {
        if(id === "BID-1-o396e-1294"){
            toast.success("Badge is valid!")
            toast.info("This badge was awarded to MEMENTO BLOCKCHAIN. The corresponding badge is the CST GOLD badge.")
        } else{
            toast.error("This badge is not valid.")
        }
    }

  return (
    <div className='landing2-containter'>
      <ToastContainer />
      <div className='landing2-header'>
        <h1>Verify<br/>
          <span data-value="CyberSanctus Badge" ref={textRef} onMouseEnter={matrixEffect}>CyberSanctus Badge</span><br/>
          Authenticity
        </h1>
        <p>
          Verify the authenticity of a <span>CyberSanctus</span> issued <span>Badge</span> by entering the associated Badge ID.
        </p>
      </div>
      <div className='landing2-cta button-flex'>
        <input type='text' placeholder='BID-1-a1b2-5678' value={badgeId} onChange={event => setBadgeId(event.target.value)} />
        <button onClick={() => verifyBadge(badgeId)} className={`cta-flex`} ><p>Verify</p></button>

      </div>
    </div>
  )
}

export default Badge